<template>
  <!-- banner -->
	<div id="home" class="banner">
		<video playsinline autoplay loop muted class="bannerVideo">
			<source src="../../public/assets/banner-bg-video-2.mp4" type="video/mp4">
		</video>	
		<div class="banner-agileinfo">
			<!-- header -->
			<div class="header">
				<div class="container">
					<div class="menu">
						<a href="" id="menuToggle"> <span class="navClosed"></span> </a>
						<nav>
							<a href="#home" class="active scroll">Home</a>
							<a href="#aboutMe" class="scroll">About Me</a>
							<a href="#projects" class="scroll">Projects</a>
							<a href="#resume" class="scroll">Resume</a>
							<a href="#contact" class="scroll">Contact</a>
							<a href="https://www.linkedin.com/in/abhiram-yalamanchili" target="_blank"><div class="menuLinkedIn"><i class="fa fa-linkedin-square" aria-hidden="true"></i></div></a>
						</nav>
					</div>
					<div class="clearfix"> </div>
				</div>
			</div>
			<!-- //header -->
			<div class="banner-text">
				<div class="container">
					
					<h2 class="w3ls-bnrtext">Abhiram Yalamanchili</h2>
					<p class="w3ls-p">A technology savvy professional with a passion to innovate, plan and deliver products that make
					our lives easier</p>
					<a href="#aboutMe" class="buy btn-wayra scroll">About me</a>
				</div>
			</div>
		</div>
	</div>
	<!-- //banner -->
</template>

<script>
export default {
  name: 'Banner'
}
</script>
<script>
	(function ($) {
		// Menu Functions
		$(document).ready(function () {
			$('#menuToggle').click(function (e) {
				var $parent = $(this).parent('.menu');
				$parent.toggleClass("open");
				var navState = $parent.hasClass('open') ? "hide" : "show";
				$(this).attr("title", navState + " navigation");
				// Set the timeout to the animation length in the CSS.
				setTimeout(function () {
					console.log("timeout set");
					$('#menuToggle > span').toggleClass("navClosed").toggleClass("navOpen");
				}, 200);
				e.preventDefault();
			});
		});
	})(jQuery);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
